<template>
  <div>
    <div v-if="inline" class="share-inline">
      <p class="share-inline__label">Partager cette recette</p>

      <div class="share-inline__list">
        <a
          :href="facebookShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--facebook"
          aria-label="Partager sur Facebook"
          title="Facebook"
        >
          <font-awesome-icon :icon="['fab', 'facebook']" />
        </a>

        <a
          :href="xShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--x"
          aria-label="Partager sur X"
          title="X"
        >
          <span>X</span>
        </a>

        <a
          :href="linkedinShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--linkedin"
          aria-label="Partager sur LinkedIn"
          title="LinkedIn"
        >
          <font-awesome-icon :icon="['fab', 'linkedin']" />
        </a>

        <a
          :href="whatsappShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--whatsapp"
          aria-label="Partager sur WhatsApp"
          title="WhatsApp"
        >
          <span>WA</span>
        </a>

        <a
          :href="telegramShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--telegram"
          aria-label="Partager sur Telegram"
          title="Telegram"
        >
          <span>TG</span>
        </a>

        <a
          :href="pinterestShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--pinterest"
          aria-label="Partager sur Pinterest"
          title="Pinterest"
        >
          <span>P</span>
        </a>

        <a
          :href="redditShareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="share-inline__item share-inline__item--reddit"
          aria-label="Partager sur Reddit"
          title="Reddit"
        >
          <span>R</span>
        </a>

        <a
          :href="emailShareUrl"
          class="share-inline__item share-inline__item--email"
          aria-label="Partager par email"
          title="Email"
        >
          <font-awesome-icon :icon="['fas', 'envelope']" />
        </a>

        <button
          type="button"
          class="share-inline__item share-inline__item--copy"
          aria-label="Copier le lien"
          title="Copier le lien"
          @click="copyLink"
        >
          <font-awesome-icon :icon="['fas', 'link']" />
        </button>

        <button
          v-if="canUseNativeShare"
          type="button"
          class="share-inline__item share-inline__item--native"
          aria-label="Partager"
          title="Partager"
          @click="nativeShare"
        >
          <font-awesome-icon :icon="['fas', 'share-alt']" />
        </button>
      </div>

      <p v-if="copied" class="share-feedback">Lien copié.</p>
    </div>

    <div v-else>
      <button class="button circle" @click.stop="openModal = true">
        <font-awesome-icon
          class="icon"
          :icon="['fas', 'share-alt']"
        />
      </button>

      <div
        v-if="openModal"
        class="modal"
        @click.self="closeModal"
      >
        <div class="modal-content">
          <h2>Partager la recette : {{ dish.name }}</h2>

          <div class="share-container">
            <a
              :href="facebookShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn facebook"
            >
              <font-awesome-icon class="icon" :icon="['fab', 'facebook']" />
              Facebook
            </a>

            <a
              :href="xShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn x"
            >
              X
            </a>

            <a
              :href="linkedinShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn linkedin"
            >
              <font-awesome-icon class="icon" :icon="['fab', 'linkedin']" />
              LinkedIn
            </a>

            <a
              :href="whatsappShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn whatsapp"
            >
              WhatsApp
            </a>

            <a
              :href="telegramShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn telegram"
            >
              Telegram
            </a>

            <a
              :href="pinterestShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn pinterest"
            >
              Pinterest
            </a>

            <a
              :href="redditShareUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="share-btn reddit"
            >
              Reddit
            </a>

            <a
              :href="emailShareUrl"
              class="share-btn email"
            >
              <font-awesome-icon class="icon" :icon="['fas', 'envelope']" />
              Email
            </a>

            <button
              type="button"
              class="share-btn copy"
              @click="copyLink"
            >
              Copier le lien
            </button>

            <button
              v-if="canUseNativeShare"
              type="button"
              class="share-btn native"
              @click="nativeShare"
            >
              Partager
            </button>
          </div>

          <p v-if="copied" class="share-feedback">Lien copié.</p>

          <div style="display: flex; justify-content: center; margin-top: 1rem;">
            <button class="button" @click="closeModal">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialSharingModal",
  props: {
    dish: {
      type: Object,
      required: true,
    },
    publicUrl: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      openModal: false,
      copied: false,
    };
  },
  computed: {
    shareUrl() {
      if (this.publicUrl) {
        return this.publicUrl;
      }

      if (typeof window !== "undefined") {
        return `${window.location.origin}/recette/${this.dish.id}`;
      }

      return `/recette/${this.dish.id}`;
    },
    shareText() {
      return this.description || `Découvrez la recette ${this.dish.name} sur Mes Meilleurs Menus.`;
    },
    encodedUrl() {
      return encodeURIComponent(this.shareUrl);
    },
    encodedText() {
      return encodeURIComponent(this.shareText);
    },
    encodedTitle() {
      return encodeURIComponent(this.dish.name);
    },
    encodedImage() {
      const photo = this.dish.photo || "";

      if (!photo) {
        return encodeURIComponent(this.shareUrl);
      }

      if (photo.startsWith("http")) {
        return encodeURIComponent(photo);
      }

      if (typeof window !== "undefined") {
        return encodeURIComponent(`${window.location.origin}${photo}`);
      }

      return encodeURIComponent(photo);
    },
    facebookShareUrl() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}`;
    },
    xShareUrl() {
      return `https://twitter.com/intent/tweet?url=${this.encodedUrl}&text=${this.encodedText}`;
    },
    linkedinShareUrl() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.encodedUrl}`;
    },
    whatsappShareUrl() {
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(`${this.shareText} ${this.shareUrl}`)}`;
    },
    telegramShareUrl() {
      return `https://t.me/share/url?url=${this.encodedUrl}&text=${this.encodedText}`;
    },
    pinterestShareUrl() {
      return `https://pinterest.com/pin/create/button/?url=${this.encodedUrl}&media=${this.encodedImage}&description=${this.encodedText}`;
    },
    redditShareUrl() {
      return `https://www.reddit.com/submit?url=${this.encodedUrl}&title=${this.encodedTitle}`;
    },
    emailShareUrl() {
      const subject = encodeURIComponent(`Recette à découvrir : ${this.dish.name}`);
      const body = encodeURIComponent(
        `${this.shareText}\n\n${this.shareUrl}`
      );
      return `mailto:?subject=${subject}&body=${body}`;
    },
    canUseNativeShare() {
      return typeof navigator !== "undefined" && typeof navigator.share === "function";
    },
  },
  methods: {
    closeModal() {
      this.openModal = false;
      this.copied = false;
    },
    copyLink() {
      if (typeof navigator === "undefined" || !navigator.clipboard) {
        return;
      }

      navigator.clipboard.writeText(this.shareUrl).then(() => {
        this.copied = true;
      });
    },
    nativeShare() {
      if (!this.canUseNativeShare) {
        return;
      }

      navigator.share({
        title: this.dish.name,
        text: this.shareText,
        url: this.shareUrl,
      });
    },
  },
};
</script>

<style scoped>
.share-inline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.share-inline__label {
  margin: 0;
  color: #35524a;
  font-size: 14px;
  font-weight: 700;
}

.share-inline__list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.share-inline__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 999px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.share-inline__item:hover {
  transform: translateY(-2px);
  opacity: 0.92;
}

.share-inline__item span {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.share-inline__item--facebook {
  background: #3b5998;
}

.share-inline__item--x {
  background: #111;
}

.share-inline__item--linkedin {
  background: #0077b5;
}

.share-inline__item--whatsapp {
  background: #25d366;
}

.share-inline__item--telegram {
  background: #229ed9;
}

.share-inline__item--pinterest {
  background: #bd081c;
}

.share-inline__item--reddit {
  background: #ff4500;
}

.share-inline__item--email {
  background: #d44638;
}

.share-inline__item--copy {
  background: #6b7280;
}

.share-inline__item--native {
  background: #004c40;
}

.share-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 1rem;
}

.share-btn {
  border: none;
  text-decoration: none;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.facebook {
  background: #3b5998;
}

.x {
  background: #111;
}

.linkedin {
  background: #0077b5;
}

.whatsapp {
  background: #25d366;
}

.telegram {
  background: #229ed9;
}

.pinterest {
  background: #bd081c;
}

.reddit {
  background: #ff4500;
}

.email {
  background: #d44638;
}

.copy {
  background: #6b7280;
}

.native {
  background: #004c40;
}

.share-feedback {
  margin-top: 12px;
  text-align: center;
  color: #004c40;
  font-weight: 700;
}
</style>
